import { SIDE_COLORS } from '@halvard/board3d';
import type { ice } from '@halvard/rules';

/** A side's mark: a dot in its warriors' colours, put before its name wherever it is named. */
export function SideDot({ side }: { side: ice.Side }) {
  return (
    <span
      className="side-dot"
      aria-hidden="true"
      style={{ background: SIDE_COLORS[side].body, borderColor: SIDE_COLORS[side].trim }}
    />
  );
}
